import staticServer from "../api/staticServer";
import { IS_DEMO_MODE } from "../constants";

export default function getFileURL(path) {
    if (IS_DEMO_MODE && path?.startsWith('/demo/')) {
        return path;
    }

    return staticServer.getFileURL(path);
}
